(() => {
  'use strict';

  const SELECTORS = {
    rubikSwatch: 'a.rcl__swatch[href*="/products/"]',

    quickAddDialog:
      'quick-add-dialog#quick-add-dialog, quick-add-dialog[data-xylo-quick-add]',

    modalContent: '#quick-add-modal-content',

    productGrid: '[data-product-grid-content]',

    productForm:
      'product-form-component form[action*="/cart/add"], form[action*="/cart/add"]',

    addButton: [
      'button[name="add"]',
      'input[name="add"]',
      'add-to-cart-component button',
      'product-form-component button[type="submit"]'
    ].join(',')
  };

  let lastQuickAddComponent = null;
  let activeRequest = 0;

  injectStyles();

  /*
   * Quick Add open karne wala original component save karta hai.
   */
  document.addEventListener(
    'click',
    rememberQuickAddSource,
    true
  );

  /*
   * Rubik swatch click handle karta hai.
   */
  document.addEventListener(
    'click',
    handleRubikSwatchClick,
    true
  );

  /*
   * Size select hone par correct variant ID update karta hai.
   */
  document.addEventListener(
    'change',
    handleVariantChange,
    true
  );

  /*
   * Add to Cart click se pehle final variant sync.
   */
  document.addEventListener(
    'click',
    syncBeforeAddToCart,
    true
  );

  /*
   * Form submit se pehle final variant sync.
   */
  document.addEventListener(
    'submit',
    syncBeforeFormSubmit,
    true
  );

  function rememberQuickAddSource(event) {
    const path = getEventPath(event);

    const component = findInPath(
      path,
      'quick-add-component'
    );

    if (!component) return;

    /*
     * Modal ke bahar product card wala Quick Add
     * component save karna hai.
     */
    if (!component.closest('quick-add-dialog')) {
      lastQuickAddComponent = component;
    }
  }

  async function handleRubikSwatchClick(event) {
    const path = getEventPath(event);

    /*
     * Rubik Shadow DOM ke andar ka actual link.
     */
    const swatch = findInPath(
      path,
      SELECTORS.rubikSwatch
    );

    if (!swatch) return;

    const quickAddDialog = findInPath(
      path,
      SELECTORS.quickAddDialog
    );

    /*
     * Product page par normal Rubik swatches
     * ko affect nahi karega.
     */
    if (!quickAddDialog) return;

    const nativeDialog =
      quickAddDialog.querySelector('dialog[open]');

    if (!nativeDialog) return;

    /*
     * Popup close aur product page redirect roko.
     */
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const productUrl = new URL(
      swatch.href,
      window.location.origin
    );

    const sourceQuickAdd =
      document.querySelector(
        'quick-add-component[stay-visible]'
      ) || lastQuickAddComponent;

    if (
      !sourceQuickAdd ||
      typeof sourceQuickAdd.fetchProductPage !==
        'function' ||
      typeof sourceQuickAdd.updateQuickAddModal !==
        'function'
    ) {
      showError(
        quickAddDialog,
        'Quick Add component nahi mila. Page refresh karke dobara try karein.'
      );

      return;
    }

    lastQuickAddComponent = sourceQuickAdd;

    const requestId = ++activeRequest;

    clearError(quickAddDialog);
    setLoading(quickAddDialog, true);

    try {
      /*
       * Selected Rubik product ka full product page fetch.
       */
      const html =
        await sourceQuickAdd.fetchProductPage(
          productUrl.toString()
        );

      if (requestId !== activeRequest) return;

      if (!html) {
        throw new Error(
          'Selected product ka HTML nahi mila.'
        );
      }

      const productGrid = html.querySelector(
        SELECTORS.productGrid
      );

      if (!productGrid) {
        throw new Error(
          '[data-product-grid-content] element nahi mila.'
        );
      }

      // const freshContent =
      //   productGrid.cloneNode(true);

      // /*
      //  * Selected product ko same open popup mein load karega.
      //  */
      // await sourceQuickAdd.updateQuickAddModal(
      //   freshContent
      // );


      await sourceQuickAdd.updateQuickAddModal(
  productGrid
);

await xyloUpdateActiveSwatch(
  quickAddDialog,
  productUrl
);

      if (requestId !== activeRequest) return;

      const modalContent =
        quickAddDialog.querySelector(
          SELECTORS.modalContent
        );

      if (!modalContent) {
        throw new Error(
          '#quick-add-modal-content nahi mila.'
        );
      }

      /*
       * Horizon native variant picker ko selected
       * product ke size variants ke saath update karega.
       */
      await customElements.whenDefined(
        'variant-picker'
      );

      const variantPicker =
        modalContent.querySelector(
          'variant-picker'
        );

      if (
        variantPicker &&
        typeof variantPicker.updateVariantPicker ===
          'function'
      ) {
        variantPicker.updateVariantPicker(
          productGrid
        );
      }

      updateProductLinks({
        quickAddDialog,
        modalContent,
        html,
        productGrid,
        productUrl,
        swatch
      });

      /*
       * Selected product ki initial variant ID sync.
       */
      forceSelectedVariantId(
        quickAddDialog
      );

      scheduleVariantSync(
        quickAddDialog
      );

      resetPopupScroll(
        quickAddDialog
      );

      document.dispatchEvent(
        new CustomEvent(
          'xylo:rubik-quick-add:changed',
          {
            detail: {
              productUrl:
                productUrl.toString(),

              productHandle:
                getProductHandle(productUrl)
            }
          }
        )
      );
    } catch (error) {
      console.error(
        '[Xylo Rubik Quick Add]',
        error
      );

      showError(
        quickAddDialog,
        'error'
      );
    } finally {
      if (requestId === activeRequest) {
        setLoading(
          quickAddDialog,
          false
        );
      }
    }
  }

  function handleVariantChange(event) {
    const control = event.target;

    if (
      !(
        control instanceof HTMLInputElement ||
        control instanceof HTMLSelectElement
      )
    ) {
      return;
    }

    const variantPicker =
      control.closest('variant-picker');

    if (!variantPicker) return;

    const quickAddDialog =
      control.closest(
        SELECTORS.quickAddDialog
      );

    if (!quickAddDialog) return;

    /*
     * Radio unchecked event ignore karein.
     */
    if (
      control instanceof HTMLInputElement &&
      ['radio', 'checkbox'].includes(
        control.type
      ) &&
      !control.checked
    ) {
      return;
    }

    /*
     * Selected size ke data-variant-id ko
     * hidden product form mein apply karta hai.
     */
    forceSelectedVariantId(
      quickAddDialog,
      control
    );

    scheduleVariantSync(
      quickAddDialog,
      control
    );
  }

  function syncBeforeAddToCart(event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest(
      SELECTORS.addButton
    );

    if (!button) return;

    const quickAddDialog =
      button.closest(
        SELECTORS.quickAddDialog
      );

    if (!quickAddDialog) return;

    /*
     * Add to Cart click ke bilkul pehle
     * selected size variant force update.
     */
    forceSelectedVariantId(
      quickAddDialog
    );
  }

  function syncBeforeFormSubmit(event) {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches(
        'form[action*="/cart/add"]'
      )
    ) {
      return;
    }

    const quickAddDialog =
      form.closest(
        SELECTORS.quickAddDialog
      );

    if (!quickAddDialog) return;

    /*
     * Shopify FormData banane se pehle
     * exact selected variant ID update.
     */
    forceSelectedVariantId(
      quickAddDialog
    );
  }

  function forceSelectedVariantId(
    quickAddDialog,
    preferredControl = null
  ) {
    const modalContent =
      quickAddDialog.querySelector(
        SELECTORS.modalContent
      );

    if (!modalContent) return false;

    const variantPicker =
      modalContent.querySelector(
        'variant-picker'
      );

    if (!variantPicker) return false;

    const variantId =
      getSelectedVariantId(
        variantPicker,
        preferredControl
      );

    if (!variantId) {
      console.warn(
        '[Xylo Rubik Quick Add] Selected variant ID nahi mili.'
      );

      return false;
    }

    const productFormComponent =
      modalContent.querySelector(
        'product-form-component'
      );

    const form =
      productFormComponent?.querySelector(
        'form[action*="/cart/add"]'
      ) ||
      modalContent.querySelector(
        'form[action*="/cart/add"]'
      );

    if (!form) {
      console.warn(
        '[Xylo Rubik Quick Add] Product form nahi mila.'
      );

      return false;
    }

    let variantInput =
      form.querySelector(
        'input[name="id"]'
      );

    /*
     * Horizon ref input available ho to
     * usko preference dein.
     */
    const referencedInput =
      productFormComponent?.refs
        ?.variantId;

    if (
      referencedInput instanceof
        HTMLInputElement
    ) {
      variantInput = referencedInput;
    }

    if (!variantInput) {
      variantInput =
        document.createElement('input');

      variantInput.type = 'hidden';
      variantInput.name = 'id';

      form.appendChild(
        variantInput
      );
    }

    /*
     * Exact selected size variant ID.
     */
    variantInput.value =
      String(variantId);

    variantInput.setAttribute(
      'value',
      String(variantId)
    );

    /*
     * Agar ref aur queried input alag hain
     * to dono update karein.
     */
    const normalInput =
      form.querySelector(
        'input[name="id"]'
      );

    if (
      normalInput &&
      normalInput !== variantInput
    ) {
      normalInput.value =
        String(variantId);

      normalInput.setAttribute(
        'value',
        String(variantId)
      );
    }

    if (
      referencedInput instanceof
        HTMLInputElement &&
      referencedInput !== variantInput
    ) {
      referencedInput.value =
        String(variantId);

      referencedInput.setAttribute(
        'value',
        String(variantId)
      );
    }

    form.dataset.variantId =
      String(variantId);

    if (productFormComponent) {
      productFormComponent.dataset.variantId =
        String(variantId);
    }

    return true;
  }

  function getSelectedVariantId(
    variantPicker,
    preferredControl = null
  ) {
    /*
     * Change event ka actual selected control
     * sabse reliable hai.
     */
    if (
      preferredControl instanceof
        HTMLInputElement &&
      preferredControl.checked &&
      preferredControl.dataset.variantId
    ) {
      return preferredControl.dataset.variantId;
    }

    if (
      preferredControl instanceof
        HTMLSelectElement
    ) {
      const selectedOption =
        preferredControl.selectedOptions?.[0];

      if (
        selectedOption?.dataset
          ?.variantId
      ) {
        return selectedOption.dataset.variantId;
      }
    }

    /*
     * Size radio ko preference.
     */
    const checkedInputs = [
      ...variantPicker.querySelectorAll(
        'fieldset input[type="radio"]:checked[data-variant-id], fieldset input[type="checkbox"]:checked[data-variant-id]'
      )
    ];

    const selectedSizeInput =
      checkedInputs.find((input) => {
        return isSizeControl(input);
      });

    if (
      selectedSizeInput?.dataset
        ?.variantId
    ) {
      return selectedSizeInput.dataset.variantId;
    }

    /*
     * Single-option product fallback.
     */
    const checkedInput =
      checkedInputs.find(
        (input) =>
          input.dataset.variantId
      );

    if (
      checkedInput?.dataset
        ?.variantId
    ) {
      return checkedInput.dataset.variantId;
    }

    /*
     * Dropdown size picker support.
     */
    const selects = [
      ...variantPicker.querySelectorAll(
        'select'
      )
    ];

    const sizeSelect =
      selects.find((select) => {
        return isSizeControl(select);
      });

    const sizeSelectedOption =
      sizeSelect?.selectedOptions?.[0];

    if (
      sizeSelectedOption?.dataset
        ?.variantId
    ) {
      return sizeSelectedOption.dataset.variantId;
    }

    const anySelectedOption =
      selects
        .map(
          (select) =>
            select.selectedOptions?.[0]
        )
        .find(
          (option) =>
            option?.dataset?.variantId
        );

    if (
      anySelectedOption?.dataset
        ?.variantId
    ) {
      return anySelectedOption.dataset.variantId;
    }

    /*
     * Current checked marker fallback.
     */
    const currentChecked =
      variantPicker.querySelector(
        '[data-current-checked="true"][data-variant-id]'
      );

    if (
      currentChecked?.dataset
        ?.variantId
    ) {
      return currentChecked.dataset.variantId;
    }

    return '';
  }

  function isSizeControl(control) {
    const optionName =
      control.dataset?.optionName ||
      control.name ||
      control.closest('fieldset')
        ?.querySelector(
          'legend, .variant-option__label, .form__label'
        )
        ?.textContent ||
      control.previousElementSibling
        ?.textContent ||
      '';

    return /size|sizes|taille|größe|tamaño/i.test(
      String(optionName)
    );
  }

  function scheduleVariantSync(
    quickAddDialog,
    preferredControl = null
  ) {
    /*
     * Horizon variant picker AJAX/morph ke baad
     * bhi correct variant ID retain karega.
     */
    requestAnimationFrame(() => {
      forceSelectedVariantId(
        quickAddDialog,
        preferredControl
      );
    });

    [100, 300, 700, 1400].forEach(
      (delay) => {
        window.setTimeout(() => {
          forceSelectedVariantId(
            quickAddDialog
          );
        }, delay);
      }
    );
  }

  function updateProductLinks({
    quickAddDialog,
    modalContent,
    html,
    productGrid,
    productUrl,
    swatch
  }) {
    const fetchedTitleLink =
      productGrid.querySelector(
        '.view-product-title a'
      );

    const ogTitle =
      html.querySelector(
        'meta[property="og:title"]'
      )?.content;

    const headingText =
      productGrid.querySelector(
        [
          '.product-details h1',
          '.product-details h2',
          'h1.product-title',
          'h2.product-title'
        ].join(',')
      )?.textContent?.trim();

    const swatchLabel =
      swatch.dataset.optionValue ||
      swatch
        .querySelector(
          '.rcl__swatch-label'
        )
        ?.textContent?.trim() ||
      '';

    const productTitle =
      fetchedTitleLink
        ?.textContent?.trim() ||
      ogTitle?.trim() ||
      headingText ||
      swatch.getAttribute(
        'aria-label'
      ) ||
      swatchLabel;

    quickAddDialog
      .querySelectorAll(
        [
          '.view-product-title a',
          '.product-header a',
          'a[data-view-full-details]'
        ].join(',')
      )
      .forEach((link) => {
        link.href =
          productUrl.toString();
      });

    const mobileTitle =
      quickAddDialog.querySelector(
        '.product-header a'
      );

    if (
      mobileTitle &&
      productTitle
    ) {
      mobileTitle.textContent =
        productTitle;
    }

    modalContent.dataset.xyloProductHandle =
      getProductHandle(productUrl);

    modalContent.dataset.xyloProductUrl =
      productUrl.pathname;
  }

  function resetPopupScroll(
    quickAddDialog
  ) {
    quickAddDialog
      .querySelector(
        '.product-details'
      )
      ?.scrollTo({
        top: 0,
        behavior: 'instant'
      });

    quickAddDialog
      .querySelector(
        '.product-information__media'
      )
      ?.scrollTo({
        top: 0,
        behavior: 'instant'
      });
  }

  function getEventPath(event) {
    return typeof event.composedPath ===
      'function'
      ? event.composedPath()
      : [event.target];
  }

  function findInPath(
    path,
    selector
  ) {
    return (
      path.find(
        (node) =>
          node instanceof Element &&
          node.matches(selector)
      ) || null
    );
  }

  function getProductHandle(url) {
    const parts = url.pathname
      .split('/')
      .filter(Boolean);

    const productIndex =
      parts.lastIndexOf('products');

    return productIndex >= 0
      ? parts[
          productIndex + 1
        ] || ''
      : '';
  }

  function setLoading(
    quickAddDialog,
    loading
  ) {
    quickAddDialog.classList.toggle(
      'xylo-rubik-is-loading',
      loading
    );

    quickAddDialog.setAttribute(
      'aria-busy',
      String(loading)
    );

    let loader =
      quickAddDialog.querySelector(
        '.xylo-rubik-loader'
      );

    if (loading && !loader) {
      loader =
        document.createElement('div');

      loader.className =
        'xylo-rubik-loader';

      loader.setAttribute(
        'aria-hidden',
        'true'
      );

      loader.innerHTML =
        '<span></span>';

      quickAddDialog
        .querySelector('dialog')
        ?.appendChild(loader);
    }

    if (!loading) {
      loader?.remove();
    }
  }

  function showError(
    quickAddDialog,
    message
  ) {
    clearError(quickAddDialog);

    const error =
      document.createElement('div');

    error.className =
      'xylo-rubik-error';

    error.setAttribute(
      'role',
      'alert'
    );

    error.textContent = message;

    const modalContent =
      quickAddDialog.querySelector(
        SELECTORS.modalContent
      );

    (
      modalContent ||
      quickAddDialog.querySelector(
        'dialog'
      )
    )?.prepend(error);
  }

  function clearError(
    quickAddDialog
  ) {
    quickAddDialog
      .querySelector(
        '.xylo-rubik-error'
      )
      ?.remove();
  }

  function injectStyles() {
    if (
      document.getElementById(
        'xylo-rubik-quick-add-css'
      )
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'xylo-rubik-quick-add-css';

    style.textContent = `
      quick-add-dialog dialog {
        position: relative;
      }

      .xylo-rubik-loader {
        position: absolute;
        inset: 0;
        z-index: 9999;
        display: grid;
        place-items: center;
        background: rgb(255 255 255 / 72%);
        backdrop-filter: blur(2px);
        cursor: wait;
      }

      .xylo-rubik-loader span {
        width: 34px;
        height: 34px;
        border: 3px solid rgb(0 0 0 / 18%);
        border-top-color: currentColor;
        border-radius: 50%;
        animation:
          xylo-rubik-spin
          0.7s linear infinite;
      }

      .xylo-rubik-error {
        position: relative;
        z-index: 10;
        margin: 12px;
        padding: 10px 12px;
        border: 1px solid currentColor;
        background: #fff7f7;
        color: #9b1c1c;
        font-size: 13px;
        line-height: 1.4;
      }

      @keyframes xylo-rubik-spin {
        to {
          transform: rotate(360deg);
        }
      }
    `;

    document.head.appendChild(
      style
    );
  }
    /* Remove only the stray “error” placeholder inside Quick Add */
  function xyloRemoveStrayQuickAddError() {
    const modal = document.querySelector(
      'quick-add-dialog#quick-add-dialog'
    );

    if (!modal) return;

    modal
      .querySelectorAll(
        [
          '[role="alert"]',
          '.product-form__error-message-wrapper',
          '.product-form__error-message',
          '.errors',
          '[class*="error"]'
        ].join(',')
      )
      .forEach((element) => {
        const text = String(element.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

        /* Genuine cart messages ko remove nahi karega */
        if (text === 'error') {
          element.remove();
        }
      });
  }

  function xyloStartErrorCleanup() {
    const modal = document.querySelector(
      'quick-add-dialog#quick-add-dialog'
    );

    if (!modal || modal.dataset.xyloErrorCleanup === 'true') {
      return;
    }

    modal.dataset.xyloErrorCleanup = 'true';

    const observer = new MutationObserver(() => {
      requestAnimationFrame(
        xyloRemoveStrayQuickAddError
      );
    });

    observer.observe(modal, {
      childList: true,
      subtree: true,
      characterData: true
    });

    xyloRemoveStrayQuickAddError();
  }

  document.addEventListener(
    'xylo:rubik-quick-add:changed',
    () => {
      setTimeout(xyloRemoveStrayQuickAddError, 0);
      setTimeout(xyloRemoveStrayQuickAddError, 300);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      xyloStartErrorCleanup,
      { once: true }
    );
  } else {
    xyloStartErrorCleanup();
  }




  


   async function xyloUpdateActiveSwatch(
  quickAddDialog,
  productUrl
) {
  const selectedHandle =
    xyloGetProductHandle(productUrl);

  if (!selectedHandle) return;

  /*
   * Rubik async render hoti hai, is liye
   * multiple delayed attempts required hain.
   */
  const delays = [
    0,
    50,
    150,
    300,
    600,
    1000,
    1600,
    2500
  ];

  delays.forEach((delay) => {
    window.setTimeout(() => {
      xyloApplyActiveSwatch(
        quickAddDialog,
        selectedHandle
      );
    }, delay);
  });
}

function xyloApplyActiveSwatch(
  quickAddDialog,
  selectedHandle
) {
  const wrapper =
    quickAddDialog.querySelector(
      '.rcl-swatch-wrapper'
    );

  if (!wrapper) return false;

  /*
   * Rubik ko selected product ka correct
   * current handle provide karta hai.
   */
  wrapper.setAttribute(
    'data-rcl-product-handle',
    selectedHandle
  );

  const rubik =
    wrapper.querySelector(
      'rubik-combined-listings'
    );

  const shadowRoot =
    rubik?.shadowRoot;

  if (!shadowRoot) return false;

  const swatches = [
    ...shadowRoot.querySelectorAll(
      'a.rcl__swatch[href*="/products/"]'
    )
  ];

  const selectedSwatch =
    swatches.find((swatch) => {
      return (
        xyloGetProductHandle(
          swatch.href
        ) === selectedHandle
      );
    });

  if (!selectedSwatch) return false;

  swatches.forEach((swatch) => {
    swatch.classList.remove(
      'rcl__swatch--active'
    );


    swatch.removeAttribute(
      'aria-current'
    );

    swatch.setAttribute(
      'aria-pressed',
      'false'
    );

    swatch.style.removeProperty(
      'border-color'
    );

    swatch.style.removeProperty(
      'box-shadow'
    );


    swatch.style.removeProperty('border-width');
swatch.style.removeProperty('outline');
  });

  selectedSwatch.classList.add(
    'rcl__swatch--active'
  );

  selectedSwatch.setAttribute(
    'aria-current',
    'true'
  );

  selectedSwatch.setAttribute(
    'aria-pressed',
    'true'
  );

  /*
   * Force visual highlight, even agar Rubik
   * class ko immediately style na kare.
   */
selectedSwatch.style.setProperty(
  'border-width',
  '1px',
  'important'
);

selectedSwatch.style.setProperty(
  'border-color',
  'rgba(0, 0, 0, 1)',
  'important'
);

selectedSwatch.style.setProperty(
  'box-shadow',
  'none',
  'important'
);

selectedSwatch.style.setProperty(
  'outline',
  'none',
  'important'
);

  const colorName =
    selectedSwatch.dataset.optionValue ||
    selectedSwatch
      .querySelector(
        '.rcl__swatch-label'
      )
      ?.textContent?.trim() ||
    '';

  const selectedValue =
    shadowRoot.querySelector(
      '.rcl__group-label-selected-value'
    );

  if (selectedValue && colorName) {
    selectedValue.textContent =
      colorName;
  }

  if (window.innerWidth <= 749) {
    selectedSwatch.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

  return true;
}

function xyloGetProductHandle(
  urlValue
) {
  try {
    const url = new URL(
      urlValue,
      window.location.origin
    );

    const parts =
      url.pathname
        .split('/')
        .filter(Boolean);

    const productIndex =
      parts.lastIndexOf('products');

    return productIndex >= 0
      ? parts[productIndex + 1] || ''
      : '';
  } catch (error) {
    return '';
  }
}


})();